import { TiptapEditorBase } from '@chiroup/components/form/TiptapEditorBase';
import { tiptapExtensions } from '@chiroup/components/form/tiptapExtensions';
import { Icons } from '@chiroup/components/icons';
import { FormError } from '@chiroup/core/types/ErrorResponse.type';
// import Emoji, { gitHubEmojis } from '@tiptap-pro/extension-emoji';
import type { JSONContent } from '@tiptap/react';
import { useMemo } from 'react';

// export const tiptapExtensions = [
//   Document,
//   Paragraph,
//   Text,
//   StarterKit,
//   Placeholder.configure({
//     placeholder: 'Enter a description...',
//   }),
//   // Emoji.configure({
//   //   emojis: gitHubEmojis,
//   //   enableEmoticons: true,
//   //   suggestion: emojiSuggestion,
//   // }),
// ];

type Props = {
  value?: JSONContent | string;
  name?: string;
  label?: string;
  onChange?: (val?: any) => any;
  className?: string;
  containerClassName?: string;
  small?: boolean;
  toolbar?: boolean;
  html?: boolean;
  text?: boolean;
  disabled?: boolean;
  extraButtons?: {
    icon: Icons;
    type: 'setContent';
    fn: () => any;
  }[];
  errors?: FormError;
  labelColor?: boolean;
  disableOrderedList?: boolean;
  rightSide?: React.ReactNode;
  ref?: React.RefObject<typeof TiptapEditorBase>;
};

export const TiptapEditor = ({
  ref,
  value,
  name,
  label,
  className = 'border block w-full border-gray-300 rounded-b-md transition duration-150 ease-in-out sm:leading-5 dark:bg-dark-gray-700 dark:border-dark-gray-600 dark:text-dark-gray-200 outline-none p-2',
  containerClassName,
  onChange,
  small,
  toolbar = true,
  html = false,
  text = false,
  disabled = false,
  extraButtons,
  errors,
  labelColor = false,
  disableOrderedList = false,
  rightSide,
}: Props) => {
  const extensionsToUse = useMemo(
    () => tiptapExtensions.filter(ext => !disableOrderedList || ext.name !== 'orderedList'),
    [disableOrderedList]
  );

  return (
    <TiptapEditorBase
      value={value}
      name={name}
      label={label}
      className={className}
      containerClassName={containerClassName}
      onChange={onChange}
      small={small}
      toolbar={toolbar}
      html={html}
      text={text}
      disabled={disabled}
      extraButtons={extraButtons}
      errors={errors}
      labelColor={labelColor}
      extensions={extensionsToUse}
      ref={ref}
      rightSide={rightSide}
    />
  );
};
